import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { SplitDetailsContent, type SplitType } from './views/SplitDetailsContent.tsx';
import { type SplitDetailsModal_address$key } from './__generated__/SplitDetailsModal_address.graphql.ts';
import { type SplitDetailsModal_paymentAddresses$key } from './__generated__/SplitDetailsModal_paymentAddresses.graphql.ts';
import { type SplitDetailsModal_viewer$key } from './__generated__/SplitDetailsModal_viewer.graphql.ts';
import { type SplitDetailsModal_nftItem$key } from './__generated__/SplitDetailsModal_nftItem.graphql.ts';

type Props = {
    singleAddress?: SplitDetailsModal_address$key | null | undefined;
    addressList?: SplitDetailsModal_paymentAddresses$key | null | undefined;
    viewer: SplitDetailsModal_viewer$key;
    nftItem: SplitDetailsModal_nftItem$key | null | undefined;
    isOpen: boolean;
    onClose: () => void;
    initialSplitType?: SplitType;
    earningsPercentageObj?: { saleEarnings: number; royaltyEarnings: number };
    showSplitMetadata?: boolean;
};

export const SplitDetailsModal: FC<Props> = ({
    singleAddress: singleAddressRef = null,
    addressList: addressListRef = null,
    viewer: viewerRef,
    nftItem: nftItemRef,
    isOpen,
    onClose,
    initialSplitType,
    earningsPercentageObj,
    showSplitMetadata = false,
}) => {
    const viewer = useFragment(
        graphql`
            fragment SplitDetailsModal_viewer on Viewer {
                ...SplitDetailsContent_viewer
            }
        `,
        viewerRef
    );
    const nftItem = useFragment(
        graphql`
            fragment SplitDetailsModal_nftItem on NftItem {
                ...SplitDetailsContent_nftItem
            }
        `,
        nftItemRef
    );
    const singleAddress = useFragment(
        graphql`
            fragment SplitDetailsModal_address on EthereumAddressType {
                ...SplitDetailsContent_address
            }
        `,
        singleAddressRef
    );
    const addressList = useFragment(
        graphql`
            fragment SplitDetailsModal_paymentAddresses on PaymentAddresses {
                ...SplitDetailsContent_paymentAddresses
            }
        `,
        addressListRef
    );

    return (
        <ModalContainer
            isOpen={isOpen}
            onClose={onClose}
            removeModalOnClose
            modalSize={showSplitMetadata ? 'medium' : 'default'}
        >
            <SplitDetailsContent
                onClose={onClose}
                singleAddress={singleAddress}
                addressList={addressList}
                viewer={viewer}
                nftItem={nftItem}
                initialSplitType={initialSplitType}
                earningsPercentageObj={earningsPercentageObj}
                showSplitMetadata={showSplitMetadata}
            />
        </ModalContainer>
    );
};
